import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

//ReactDOM.render(<App />, document.getElementById('root'));

const appRoot = document.getElementById('root');

appRoot.setAttribute('notranslate', true);

ReactDOM.render(<App />, appRoot);

